<template>

    <div class="container " style="padding-top:70px;">
        <div class="row">
            <div class="col-sm-2" v-if="webW">
                <div id="JfLeftMenuOut">
                    <div :class="(fixedLeftmenu?'fixedMenuCls':'')"
                         :style="fixedLeftmenu?('width:'+LeftMenuWidth+'px'):''" id="JfLeftMenu">
                        <MyMessageLeft></MyMessageLeft>
                    </div>
                    <div v-if="fixedLeftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                </div>


            </div>

            <div :class="(webW?'col-sm-7':'col-sm-12')">


                <div style="overflow-x: hidden;">


                    <div :class="webW?'pcStyle':'phoneStyle'" id="zhutiMain">
                        <div>
                            {{query.seltype=='hit'?'被点赞':''}}
                            {{query.seltype=='comment'?'被评论':''}}
                            <!-- {{query.seltype=='at'?'被@':''}} -->
                            <el-switch
                                    v-if="webW"
                                    @click="openAutoReflashFunc"
                                    style="float: right;padding-top: 10px;margin-right: 10px;"
                                    active-text="下拉刷新"
                                    v-model="openAutoReflash"
                                    active-color="#13ce66"
                                    inactive-color="#dddddd">
                            </el-switch>
                        </div>
                        <br>
                        <div v-for="(t,i) in tableData">
                            <div class="pinglunkuangdibu"><!-- 
                                <div slot="header" class="clearfix">
                                    <span class="xiaoxidian" v-if="t.isread=='0'"></span>&nbsp; <span class="typedesc">{{t.cts}}</span>
                                    <el-button @click="delhandle(t,i)" style="float: right; padding: 3px 0" type="text" icon="el-icon-delete">删除</el-button>
                                </div> -->
                                <div class="typedesc">
                                    <div v-if="t.mtype=='hitForum'||t.mtype=='cancelHitForum'">
                                        <span>
                                        <img :src="t.faceimg" :class="webW?'pcavatar':'phoneavatar'" >
                                        <span class="reddrop" v-if="t.isread=='0'" ></span>
                                        </span>
                                        <span class="m_uname hander" @click="goUHome(t.muid)">{{t.uname}}</span>{{t.cts}}{{t.mtype=='cancelHitForum'?'取消':''}}点赞了<span
                                            class="m_forum hander" @click="goforum(t)">{{t.ftitle}}</span><el-button @click="delhandle(t,i)" style="float: right; padding: 3px 0;color: red;" type="text" icon="el-icon-delete"></el-button>
                                    </div>

                                    <div v-if="t.mtype=='hitComment'||  t.mtype=='cancelHitComment'">
                                        <p>
                                        <span>
                                        <img :src="t.faceimg" :class="webW?'pcavatar':'phoneavatar'" >
                                        <span class="reddrop" v-if="t.isread=='0'" ></span>
                                        </span>
                                        <span class="m_uname hander" @click="goUHome(t.muid)">{{t.uname}}</span>{{t.cts}}{{t.mtype=='cancelHitComment'?'取消':''}}点赞了你的评论<span class="m_forum hander" @click="goforum(t)">{{t.ftitle}}</span><el-button @click="delhandle(t,i)" style="float: right; padding: 3px 0;color: red;" type="text" icon="el-icon-delete"></el-button>
                                        </p>
                                        <div v-if="t.cont!=null" v-html="t.cont" class="mpl hh"></div>
                                        <div v-if="t.cont==null" class="mpl">该评论已删除</div>
                                    </div>

                                    <div v-if="t.mtype=='ForumComment' || t.mtype=='delForumComment' ">
                                        <p>
                                        <span>
                                        <img :src="t.faceimg" :class="webW?'pcavatar':'phoneavatar'" >
                                        <span class="reddrop" v-if="t.isread=='0'" ></span>
                                        </span>
                                        <span class="m_uname hander" @click="goUHome(t.muid)">{{t.uname}}</span>{{t.cts}}{{t.mtype=='ForumComment'?'评论了':'删除了评论'}}<span class="m_forum hander" @click="goforum(t)">{{t.ftitle}}</span><el-button @click="delhandle(t,i)" style="float: right; padding: 3px 0;color:red;" type="text" icon="el-icon-delete"></el-button>
                                        </p>
                                        <div v-if="t.cont!=null" v-html="t.cont" class="mpl hh"></div>
                                        <div v-if="t.cont==null" class="mpl">该评论已删除</div>
                                    </div>
  

                                    <div v-if="t.mtype=='replayComment' ">
                                        <p>
                                        <span>
                                        <img :src="t.faceimg" :class="webW?'pcavatar':'phoneavatar'" >
                                        <span class="reddrop" v-if="t.isread=='0'" ></span>
                                        </span>
                                        <span class="m_uname hander" @click="goUHome(t.muid)">{{t.uname}}</span>{{t.cts}}回复了<span class="m_forum hander" @click="goforum(t)">{{t.ftitle}}</span><el-button @click="delhandle(t,i)" style="float: right; padding: 3px 0;color:red;" type="text" icon="el-icon-delete"></el-button>
                                        </p>
                                        <div v-if="t.cont!=null" v-html="t.cont" class="mpl hh"></div>
                                        <div v-if="t.cont==null" class="mpl">该评论已删除</div>
                                    </div>

                                    <div v-if="t.mtype=='commentAt' ">
                                        <p>
                                        <span>
                                        <img :src="t.faceimg" :class="webW?'pcavatar':'phoneavatar'" >
                                        <span class="reddrop" v-if="t.isread=='0'" ></span>
                                        </span>
                                        <span class="m_uname hander" @click="goUHome(t.muid)">{{t.uname}}</span>{{t.cts}}在评论里 @ 了你<span class="m_forum hander" @click="goforum(t)">{{t.ftitle}}</span><el-button @click="delhandle(t,i)" style="float: right; padding: 3px 0;color:red;" type="text" icon="el-icon-delete"></el-button>
                                        </p>
                                        <div v-if="t.cont!=null" v-html="t.cont" class="mpl hh"></div>
                                        <div v-if="t.cont==null" class="mpl">该评论已删除</div>
                                    </div>


                                    <div v-if="t.mtype=='forumAt' ">
                                        <p>
                                        <span>
                                        <img :src="t.faceimg" :class="webW?'pcavatar':'phoneavatar'" >
                                        <span class="reddrop" v-if="t.isread=='0'" ></span>
                                        </span>
                                        <span class="m_uname hander" @click="goUHome(t.muid)">{{t.uname}}</span>{{t.cts}}在帖子里 @ 了你<span class="m_forum hander" @click="goforum(t)">{{t.ftitle}}</span><el-button @click="delhandle(t,i)" style="float: right; padding: 3px 0;color:red;" type="text" icon="el-icon-delete"></el-button>
                                        </p>
                                    </div>

                                </div>

                            </div>
                            <br>
                        </div>


                        <div class="baiseback" v-if="tableDataloading">
                            <div class="center">
                                <img src="../../../assets/img/loading.gif">
                                <p class="typedesc">数据加载中....</p>
                            </div>
                        </div>
                        <div class="baiseback" style="height: 100vh;" v-if="!tableDataloading&&tableData.length==0">
                            <div class="center">
                                <img src="../../../assets/img/zwsj.png">
                                <p class="typedesc">暂无数据</p>
                            </div>
                        </div>


                        <div class="center">
                            <el-pagination v-if="webW"
                                           @current-change="handlePageChange"
                                           :current-page="query.pageNo"
                                           :page-size="query.pageSize"
                                           layout="total, prev, pager, next"
                                           :total="pageTotal">
                            </el-pagination>


                        </div>

                        <p class="typedesc center" v-if="tableDataFinish">没有数据了</p>
                    </div>
                    <div class="baiseback">
                        <Footer></Footer>
                    </div>
                </div>

                <div class="h100"></div>
                <img src="../../../assets/img/top.png" @click="gotopFunc" v-if="scrolltop" class="gotop hander">

            </div>


        </div>


    </div>

</template>
<script>

    import {dealResult, getWindowWidth} from '../../../api/common'
    import {myMessagePage, delMyMessageById} from '../../../api';
    import PubSub from 'pubsub-js'

    import Footer from "../Footer";
    import MyMessageLeft from "./MyMessageLeft";

    export default {
        name: 'Message',
        components: {
            Footer,
            MyMessageLeft,
        },

        data() {
            return {
                webW: true,

                openAutoReflash: true,
                scrolltop: false,

                nouse: false,//禁用
                //菜单固定
                fixedLeftmenu: false,
                LeftMenuWidth: 0,


                openAutoReflash: true,
                scrolltop: false,

                nouse: false,//禁用


                lander: {},
                seltype: 'hit',

                // 信息
                tableData: [],
                tableDataloading: true,
                tableDataFinish: false,//避免滚动条在最后一直请求

                query: {
                    tyepId: '',
                    pageNo: 1,
                    pageSize: 10,
                },
                pageTotal: 0,


            };
        },
        methods: {
            goforum(t) {
                this.$router.push('ForumDetail?id=' + t.forumId);
            },
            gotopFunc() {
                if(document.documentElement!=undefined)document.documentElement.scrollTop=0;
                if(document.body!=undefined) document.body.scrollTop=0;
            },


            openAutoReflashFunc() {
                if (this.openAutoReflash) this.tableDataFinish = false;
            },

            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.tableData = [];
                this.getMyMessagePageFunc();

                this.tableDataFinish = false;

                let forumMain = document.getElementById('zhutiMain');
                let top = forumMain.offsetTop;
                document.documentElement.scrollTop = top;
                document.body.scrollTop = top;

            },


            //获取帖子分页
            getMyMessagePageFunc() {
                this.lander = JSON.parse(this.$store.state.logininfo);

                this.tableDataloading = true;
                this.tableDataFinish = false;

                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;


                myMessagePage(this.query).then((res) => {
                    this.tableDataloading = false;
                    dealResult(res.data);


                    if (res.data.status == 1) {


                        let li = res.data.obj.list;
                        if (li.length == 0) {

                            this.tableDataFinish = true;

                            return;
                        }


                        this.tableData = this.tableData.concat(li);
                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                        if (this.openAutoReflash) {
                            if (res.data.obj.hasNextPage) this.query.pageNo = res.data.obj.nextPage;
                            else this.query.pageNo = this.query.pageNo + 1;
                        }


                        PubSub.publish('changeMyNotReadMessageNum', "1");

                        this.fixedmenu();

                    } else {
                        this.tableDataFinish = true;
                        this.$message.error(res.data.msg)
                    }
                })
            },


            delhandle(t, index) {

                // this.$confirm("确定删除  " + (this.query.seltype == 'fans' ? t.uname : t.tuname) + " ？ ", "提示", {
                //     type: "warning",
                // }).then(() => {
                    this.loading = this.$loading({
                        lock: true,
                        text: "请求中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.5)",
                    });
                    let o = {id: t.id, uid: this.lander.uid, token: this.lander.token}
                    delMyMessageById(o).then((res) => {
                        this.loading.close();
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.success(res.data.msg)
                            this.tableData.splice(index, 1);
                            this.pageTotal=this.tableData.length;
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })
                // });


            },
            fixedmenu(){

                let JfLeftMenu = document.getElementById('JfLeftMenu');

                let that=this;
                window.onscroll = function () {

                    let t = document.documentElement.scrollTop || document.body.scrollTop;
                    let h = document.documentElement.scrollHeight  ;
                    let wh = document.documentElement.clientHeight  ;




                    if (that.webW) {
                        that.LeftMenuWidth = JfLeftMenu.offsetWidth;

                        //t+wh=h

                        //必须写到onscroll里，因为高度是会变化的
                        let leftHeight = JfLeftMenu.offsetHeight;
                        let leftTop = JfLeftMenu.offsetTop;
                        if (t > leftTop + leftHeight) {
                            that.fixedLeftmenu = true;
                        } else {
                            that.fixedLeftmenu = false;
                        }


                    }


                    //出现回到顶部按钮
                    if (t > wh) that.scrolltop = true;
                    else that.scrolltop = false;


                    //滚动条到底部加载数据
                    if(t+wh>=h-100 && that.openAutoReflash && !that.tableDataFinish){

                        if(!that.tableDataloading)that.getMyMessagePageFunc();
                    }



                }

            },

            goUHome(uid){
                this.$router.push('Home?type=myforum&authorId='+uid);
            },
        }, mounted() {
            this.webW = getWindowWidth() >= 1000 ? true : false;
            this.lander = JSON.parse(this.$store.state.logininfo);



            if (this.$route.query.mymessagetype == undefined) this.query.seltype = "hit";
            else this.query.seltype = this.$route.query.mymessagetype;


            this.query.pageNo = 1;
            this.tableData = [];
            this.getMyMessagePageFunc();

            this.fixedmenu();
        }, watch: {
            $route: function (value) {
                if (value.query.mymessagetype != undefined && value.query.mymessagetype != this.query.seltype) {
                    this.query.seltype = value.query.mymessagetype;
                    this.query.pageNo = 1;
                    this.tableData = [];
                    this.getMyMessagePageFunc();

                }


            }
        },
        activated() {

                this.fixedmenu();
        },
        deactivated() {

        }

    };
</script>
<style scoped>


    .m_uname {
        color: #f40;
        margin:  5px;
        vertical-align:center
    }

    .m_forum {
        color: #0a8cd2;
        margin-left: 5px;
    }

    .mpl {
        padding: 10px;
        background: #f3f3f3;
    }

    .pcavatar {
        width: 30px;
        height: 30px;
        border-radius: 50%
    }
    .pcname {
        font-size: 14px;
        padding-left: 12px;
        font-weight: bold
    }
    .phoneavatar {
        width: 23px;
        height: 23px;
        border-radius: 50%;
    }
    .phonename {
        font-size: 12px;
        padding-left: 10px
    }
    .pctitle {
        font-size:22px;
    }
    .phonetitle {
        font-size: 18px;
    }
    .reddrop{
      position: relative;
      top:-8px;
      right: 6px;
      width: 10px;
      height: 10px;
      line-height: 16px;
      background: #F40;
      border-radius: 10px;
      display: inline-block;
    }
    .vertical-top {
      vertical-align: top
    }
    .pcStyle{
      background: #FFF;
      padding: 10px 10px;
      font-size: 16px;
    }
    .phoneStyle{
      background: #FFF;
      padding: 10px 0;
      font-size: 16px;
    }
</style>
